import {OidcClientSettings} from "oidc-client-ts";
import {MessageDescriptor} from "react-intl";
import {GroupFilterType} from "./api";
import {useParams} from "react-router";

export type KeysMatching<T, V> = {[K in keyof T]-?: T[K] extends V ? K : never}[keyof T];

/// returns the domainId URI parameter as number
/// for components on pages that have a :domainId parameter
export function useDomainIDParam(): number {
    const params = useParams();
    return parseInt(params.domainId || "0");
}

export type NotificationVariant = "success" | "warning" | "error" | "info";

export type NotificationMessageVars = {[key: string]: any};

export type Notification = {
    show: boolean;
    message: MessageDescriptor;
    variant: NotificationVariant;
    messageVars: NotificationMessageVars;
    autoHideDuration: number;
};

export type BackendErrorCode =
    | "not_authorized"
    | "unreachable"
    | "invalid_session"
    | "expired_access_token"
    | "unknown_access_token"
    | "cant_reach_heimdall"
    | "unknown";

export type BackendError = {
    code: BackendErrorCode;
    details?: string;
};

type EventHandler = (event: any) => void;

export type DefaultTheme = {
    baseColor?: string;
    logoImage?: string;
    backgroundImage?: string;
    backgroundColor?: string;
};

declare global {
    interface Element {
        onclick: string | EventHandler;
    }

    interface Window {
        oidcClientSettings: OidcClientSettings;
        heimdallApiUrl: string;
        heimdallBaseUrl: string;
        defaultTheme: DefaultTheme;
    }

    interface HTMLMediaElement {
        // the setSinkId is experimental right now, but we are brave
        setSinkId: (deviceId: string) => Promise<void>;
    }
}

export type SelectedMediaDevices = {[K in MediaDeviceKind]: string};

export type WebClientGrant = "enabled" | "disabled" | "ask";

export type MediaCapabilities = {[K in MediaDeviceKind]: boolean};

export function createGroupFilterVar(value: GroupFilterType) {
    return {
        typeName: "GroupFilterType",
        value,
    };
}
